import React from 'react';

function SelectionDefault({ fill = '#545659', width = 20, height = 20, style }) {
  return (
    <svg style={style} width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.62484 15.5417L1.6665 12.5833L2.5415 11.7083L4.62484 13.7708L8.354 10.0417L9.229 10.9375L4.62484 15.5417ZM4.62484 8.875L1.6665 5.91667L2.5415 5.04167L4.62484 7.10417L8.354 3.375L9.229 4.27083L4.62484 8.875ZM10.8332 13.9583V12.7083H18.3332V13.9583H10.8332ZM10.8332 7.29167V6.04167H18.3332V7.29167H10.8332Z" fill={fill} />
    </svg>

  );
}

export default SelectionDefault;
